// extracted by mini-css-extract-plugin
export default {"markdown-editor":"_-web-client-js-react-components-___MarkdownEditor-module__markdown-editor___o1Nw7"};